/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { Interpolation, css } from 'styled-components';

export const breakpoints = {
    XXL: 1440, // 1440+ Super wide Desktop
    XL: 1280, // From 1280 to 1439 - Wide Desktop
    L: 1025, // From 1024 to 1279 - Desktop
    M: 560, // From 560 to 1024 - Tablet
    S: 375, // From 375 to 559 - Mobile
    XS: 0 // Less 375 - Narrow mobile - iphone 6,7,8 and less
};

export type MediaQueryFunction = (
    content: Interpolation<any> | string
) => Interpolation<any>;
export type Breakpoint = keyof typeof breakpoints;

export const sizes = Object.keys(breakpoints) as Breakpoint[];

/**
 * Обертка над css-медиазапросами с заранее определенными брейкпоинтами.
 */
export const mediaQuery = (
    breakpoint: Breakpoint,
    less = true,
    from = false,
    more = true
): MediaQueryFunction => {
    const index = sizes.indexOf(breakpoint);
    const nextBreakpoint = sizes[index - 1] as Breakpoint;

    const min =
        breakpoints[breakpoint] > 0 && (!less || from)
            ? breakpoints[breakpoint]
            : null;
    const max =
        breakpoints[nextBreakpoint] && (!from || !more)
            ? breakpoints[nextBreakpoint] - 1
            : null;

    if (min === null && max !== null) {
        return (content) => css`
            @media (max-width: ${max}px) {
                ${content}
            }
        `;
    }

    if (min !== null && max !== null) {
        return (content) => css`
            @media screen and (min-width: ${min}px) and (max-width: ${max}px) {
                ${content}
            }
        `;
    }

    return (content) => css`
        @media (min-width: ${min}px) {
            ${content}
        }
    `;
};

export const mobileMediaQuery: MediaQueryFunction = (content) =>
    mediaQuery('S')(content);
export const notMobileMediaQuery: MediaQueryFunction = (content) =>
    mediaQuery('M', false, true)(content);
export const onlyTabletMediaQuery: MediaQueryFunction = (content) =>
    mediaQuery('M', false)(content);
export const desktopMediaQuery: MediaQueryFunction = (content) =>
    mediaQuery('L', false, true)(content);
export const notDesktopMediaQuery: MediaQueryFunction = (content) =>
    mediaQuery('M', true)(content);

export const showOnlyMobileMixin = notMobileMediaQuery(css`
    display: none !important;
`);

export const showOnlyDesktopMixin = notDesktopMediaQuery(css`
    display: none !important;
`);

export const showNotDesktopMixin = desktopMediaQuery(css`
    display: none !important;
`);

export const showNotMobileMixin = mobileMediaQuery(css`
    display: none !important;
`);

export const showOnlyTabletMixin = css`
    ${mobileMediaQuery(css`
        display: none !important;
    `)}

    ${desktopMediaQuery(css`
        display: none !important;
    `)}
`;

export function onlyMobileComponent<T>(component: React.ComponentType<T>) {
    return styled(component)`
        ${showOnlyMobileMixin}
    `;
}

export function notMobileComponent<T>(component: React.ComponentType<T>) {
    return styled(component)`
        ${showNotMobileMixin}
    `;
}

export function notDesktopComponent<T>(component: React.ComponentType<T>) {
    return styled(component)`
        ${showNotDesktopMixin}
    `;
}

export const NotMobileContainer = styled.div`
    ${showNotMobileMixin}
`;

export const OnlyMobileContainer = styled.div`
    ${showOnlyMobileMixin}
`;

export const OnlyDesktopContainer = styled.div`
    ${showOnlyDesktopMixin}
`;

export const NotDesktopContainer = styled.div`
    ${showNotDesktopMixin}
`;

export const OnlyTabletContainer = styled.div`
    ${showOnlyTabletMixin}
`;
